import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import SidebarDropdown from '../SidebarDropdown';
import { getMenuLinks } from './utils';
import { ReactComponent as InventaLogo } from 'src/img/inventa-logo.svg';
import { ReactComponent as InventaShortLogo } from 'src/img/inventa-short-logo.svg';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { vendorsPortalApi } from 'src/services/api';
import { captureException } from '@sentry/react';

const LogoContainer = styled.div`
  min-height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const LogoElement = styled.div`
  justify-content: center;
  align-items: center;
  min-height: 77px;
`;

const usePathName = () => {
  const location = useLocation();
  return location.pathname;
};

function AsideNavbar() {
  const [quotationFeatureFlag, setQuotationFeatureFlag] = useState(false);

  useEffect(() => {
    const fetchFeatureFlag = async () => {
      try {
        const { data } = await vendorsPortalApi.get(
          '/api/quotation/feature-flag',
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        setQuotationFeatureFlag(data);
      } catch (error) {
        captureException(error);
      }
    };

    fetchFeatureFlag();
  }, []);

  const menuLinks = useMemo(
    () => getMenuLinks(quotationFeatureFlag),
    [quotationFeatureFlag],
  );

  return (
    <nav
      className={clsx(
        'navbar-default navbar-static-side white-bg border-right',
        styles.navRoot,
      )}
      role="navigation"
    >
      <div className="sidebar-collapse" id="side-menu">
        <div className="nav-header p-0">
          <LogoContainer className="dropdown profile-element">
            <a
              className="d-flex justify-content-center navbar-brand logo text-dark m-0 p-0 text-center w-100"
              href="/"
            >
              <InventaLogo alt="InventaLogo" className="logo-svg" />
            </a>
          </LogoContainer>
          <LogoElement
            className="logo-element"
            onClick={() => window.location.replace('/')}
          >
            <InventaShortLogo
              alt="InventaShortLogo"
              style={{ maxHeight: 24 }}
            />
          </LogoElement>
        </div>
        <SidebarDropdown menu={menuLinks} activeUrl={usePathName()} />
      </div>
    </nav>
  );
}

export default AsideNavbar;
